import type { FeatureFlags } from '../shared/types/feature-flags';

export function useFeatureFlags() {
  return useState<FeatureFlags>('feature-flags', () => ({}));
}

export function useFeatureFlag(key: string) {
  const value = useFeatureFlags().value[key];

  if (import.meta.dev && value === undefined) {
    console.warn(`[feature-flags] no value for "${key}"`);
  }

  return value;
}
